export enum HeaderItemType {
  Text,
  Date,
  Money,
  Link,
  Email,
  Array,
  StrictValue,
  Boolean,
}
